import { atom } from 'jotai';

import { companyIdAtom } from './companyIdAtom';
import { repairMessageAtom } from './repairMessageAtom';
import { selectedRepairsAsyncAtom } from './selectedRepairsAsyncAtom';

export const damageTypePageValidAsyncAtom = atom(async (get) => {
  const selectedRepairs = await get(selectedRepairsAsyncAtom);
  const repairMessage = get(repairMessageAtom);
  const companyId = get(companyIdAtom);

  return Boolean(
    (selectedRepairs !== undefined && selectedRepairs.length > 0) ||
      repairMessage ||
      companyId !== undefined
  );
});
